import { render, staticRenderFns } from "./anchorList.vue?vue&type=template&id=35d19bcc&scoped=true&"
import script from "./anchorList.vue?vue&type=script&lang=js&"
export * from "./anchorList.vue?vue&type=script&lang=js&"
import style0 from "./anchorList.vue?vue&type=style&index=0&id=35d19bcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d19bcc",
  null
  
)

export default component.exports